export default __webpack_public_path__ + "static/media/abstract_box_flowers_still_life.d7b1b802.jpg";